import React from 'react';

const Sustainability: React.FC = () => {
  return (
    <div className="relative min-h-screen w-full">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("/forest.png")',
        }}
      />
      
      <div className="relative z-10 flex min-h-screen flex-col items-start justify-start px-20 pt-44">
        <h1 className="mb-4 text-3xl font-medium text-white md:text-5xl lg:text-6xl">
          Innovating Today for the World
        </h1>
        
        <p className="text-3xl font-medium text-white md:text-5xl lg:text-6xl">
           We Dream of Tomorrow
        </p>
      </div>
    </div>
  );
};

export default Sustainability;